import { evenRound } from 'util/NumberUtils';
import { API } from '../../api/API';
import {
    DONATION_URL, BUSINESS_DONATION_CAUSES,
    NOLOGIN_PAYMENT_INTENTS_URL, DONATION_INTENT_STATUS_URL,
    SPONSORSHIPS_URL
} from '../../config/config';
import _ from "lodash";
import { formatDateToYYYYMMDD } from 'util/Date';

const PAGE_SIZE = 6;

export const cancelPaymentIntent = async (paymentIntentId) => {
    let paymentIntentCancelResponse = await API.delete(NOLOGIN_PAYMENT_INTENTS_URL + "/" + paymentIntentId);
    return paymentIntentCancelResponse.data;
}

export const getPaymentIntentBare = async (formData) => {
    let dliClone = _.cloneDeep(formData.donationLineItems.filter(donationLineItems => {
        return donationLineItems.lineItemAmount > 0;
    }));
    for (let donationLineItem of dliClone) {
        donationLineItem.lineItemAmount = parseFloat(donationLineItem.lineItemAmount) * 100;
    }
    let paymentIntentResponse = await API.post(NOLOGIN_PAYMENT_INTENTS_URL, {
        paymentAmount: formData.totalDonationAmount * 100,
        currency: "CAD",
        donationLineItems: dliClone,
        donorEmailAddress: formData.donorEmailAddress,
        firstName: formData.firstName,
        lastName: formData.lastName,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zip: formData.zip,
        country: "CA",
        mobilePhoneNumber: formData.mobilePhoneNumber
    });
    return paymentIntentResponse.data;
}

export const getPaymentIntentStatus = async (paymentIntentId) => {
    let paymentIntentResponse = await API.get(DONATION_INTENT_STATUS_URL + "/" + paymentIntentId);
    return paymentIntentResponse.data;
}

const saveDonationInfo = async (formData) => {
    let donationLineItems = formData.donationLineItems;
    let dliClone = _.cloneDeep(donationLineItems.filter(donationLineItems => {
        return donationLineItems.lineItemAmount > 0;
    }));
    for (let donationLineItem of dliClone) {
        donationLineItem.lineItemAmount = parseFloat(donationLineItem.lineItemAmount) * 100;
    }

    let saveDonationResp = null;

    if (formData.authenticated) {
        saveDonationResp = await API.post(DONATION_URL, {
            currency: "CAD",
            confirmCardPaymentResponse: formData.paymentIntent,
            donationLineItems: dliClone
        });
    } else {
        saveDonationResp = await API.post(DONATION_URL + "/nologin", {
            donorEmailAddress: formData.donorEmailAddress,
            firstName: formData.firstName,
            lastName: formData.lastName,
            address: formData.address,
            city: formData.city,
            state: formData.state,
            zip: formData.zip,
            country: "CA",
            currency: "CAD",
            mobilePhoneNumber: formData.mobilePhoneNumber,
            confirmCardPaymentResponse: formData.paymentIntent,
            donationLineItems: dliClone
        });
    }
    return saveDonationResp.data;
}

export const makeDonation = async (stripe, formData) => {

    let saveDonationResp = await saveDonationInfo(formData);
    let confirmCardPaymentResponse = await stripe.confirmPayment({
        elements: formData.elements,
        confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: formData.returnLocation,
        },

    });

    if (!confirmCardPaymentResponse || confirmCardPaymentResponse.error) {
        console.log("Confirm card payment was not returned");
        throw confirmCardPaymentResponse.error;
    }
}

export const getDonationCauses = async (isAdmin) => {
    let donationCauseUrl = BUSINESS_DONATION_CAUSES;
    if (isAdmin){
        donationCauseUrl = BUSINESS_DONATION_CAUSES+"?nonactive=true";
    }
    let donationCausesResponse = await API.get(donationCauseUrl)
    return donationCausesResponse.data;
}

export const getDonation = async (donationId) => {
    let donationResponse = await API.get(DONATION_URL + "/" + donationId)
    return donationResponse.data;
}


export const getSponsorships = async (donationCauseId, currentPage, titleFilter) => {
    let sponsorships = await API.get(SPONSORSHIPS_URL + "/" + donationCauseId + "/unsponsored",
        { params: { size: PAGE_SIZE, page: currentPage, title: titleFilter } });
    const oneYearForward = new Date();
    oneYearForward.setFullYear((new Date()).getFullYear() + 1);
    oneYearForward.setDate(oneYearForward.getDate() - 1);
    
    for (let sps of sponsorships.data.content) {
        sps.maxAmount = evenRound(parseFloat(sps.maxAmount) / 100, 2);
        if (sps.sponsorshipType === 'RECURRING'){
            sps.frequency = 'MONTHLY';
            sps.endDate = formatDateToYYYYMMDD(oneYearForward);
            sps.freqAmount = evenRound(parseFloat(getTotalAmountWithFrequency(sps)), 2);
        } else {
            sps.frequency = 'ONE_TIME';
            sps.endDate = '';
            sps.freqAmount =  sps.maxAmount;
        }
    }
    return sponsorships.data;

};

export const calculatedTotalDonationAmount = (donationLineItems) => {
    let totalDonationAmount = 0.00;
    for (let donationLineItem of donationLineItems) {
        totalDonationAmount = evenRound(totalDonationAmount + parseFloat(donationLineItem.lineItemAmount), 2);
    }
    return totalDonationAmount;
}

export const getTotalAmountWithFrequency = (sponsorship) => {
    if (sponsorship.hasOwnProperty('frequency') && sponsorship.frequency === 'ANNUALLY') {
        return evenRound(parseFloat(sponsorship.maxAmount) * 12, 2)
    }
    return evenRound(parseFloat(sponsorship.maxAmount) * 1, 2)
}



